module.exports = __webpack_public_path__ + "static/media/desktop.909d66c5.mp4";